<template>
  <div class="form-common" v-cloak>
    <form id="register_form" class="tc" @submit.prevent="submitForm(regInfo)" autocomplete="off">
      <h3 class="title">Create an account</h3>
      <div class="input-group-wrap">
        <div class="input-group flex-row" :class="{error: validation.hasError('regInfo.username') || validateName}">
          <label for="name" class="prefix pc-view">{{ hostname }}/</label>
          <label v-if="hostname.length <= 12" for="name" class="prefix mobile-view">{{ hostname }}/</label>
          <input id="name" type="text" placeholder="username" class="name" v-model.trim="regInfo.username">
        </div>
        <p class="error-msg tl">{{ validation.firstError('regInfo.username')|| errName}}</p>
      </div>
      <div class="input-group-wrap">
        <div class="input-group" :class="{error: validation.hasError('regInfo.email') || validateEmail}">
          <input class="email w-100" type="text" placeholder="Email" v-model.trim="regInfo.email" >
        </div>
         <p class="error-msg tl">{{ validation.firstError('regInfo.email') || errEmail}}</p> 
      </div>
      <div class="input-group-wrap">
        <div class="input-group" :class="{error: validation.hasError('regInfo.password') || validatePsw}">
          <input class="psw w-100" :type='showPwd? "text" : "password"' placeholder="Password" v-model.trim="regInfo.password" autocomplete="new-password">
          <i class="iconfont" :class="showPwd?'icon-eye-fill':'icon-eye-off-fill'" @click="handlePwdVisibility"></i>
        </div>
        <p class="error-msg tl">{{ validation.firstError('regInfo.password') || errPsw}}</p> 
      </div>
      <div class="input-group-wrap">
        <div class="input-group" :class="{error: validation.hasError('confirmPwd')}">
          <input class="psw w-100" :type='showConfirmPwd? "text" : "password"' placeholder="Confirm password" v-model.trim="confirmPwd">
          <i class="iconfont" :class="showConfirmPwd?'icon-eye-fill':'icon-eye-off-fill'" @click="confirmPwdVisibility"></i>
        </div>
        <p class="error-msg tl">{{ validation.firstError('confirmPwd')}}</p> 
      </div>
      <div class="tnc">
        <div class="flex-row rel">
          <i class="iconfont disable-icon icon-checkbox-blank-line"
             @click="handleToggleIcon()"></i>
          <i class="iconfont disable-icon icon-checkbox-line" :class="{'agree': regInfo.is_agree}"
             @click="handleToggleIcon()"></i>
          <div class="tl privacy">By creating an account you are agreeing to our 
            <a href="javascript:void(0)" class="link">Terms and Conditions</a> and 
            <a href="javascript:void(0)" class="link">Privacy Policy</a>
          </div>
        </div>
        <p class="error-msg tl">{{ validation.firstError('regInfo.is_agree')}}</p> 
      </div>
      <button :class="['btn','submit-btn',{loading: is_loading}]" type="submit" :style="disableBtn">Sign up with email</button>
      <a href="javascript:void(0)" class="remind link login-link" @click='toLogin'>Already have an account?</a>
    </form>
  </div>
</template>

<script>
import loading from "../../common/utils/loading";
import userService from "../service/userService";
import LS from "local-storage";
import {validateError} from "../../common/utils/errors";
import Vue from 'vue';
import SimpleVueValidation from 'simple-vue-validator';
const Validator = SimpleVueValidation.Validator;
Vue.use(SimpleVueValidation);

export default {
  name: "register",

  data() {
    return {
      validateName: false,
      validateEmail: false,
      validatePsw: false,
      errName: '',
      errEmail: '',
      errPsw: '',
      is_loading: false,
      regInfo: {
        username: '',
        email: '',
        password: '',
        is_agree: false,
      },
      showPwd:false,
      confirmPwd:'',
      submitted: false,
      showConfirmPwd:false,
    }
  },

  validators: {
    'regInfo.username': function(value) {
      return Validator.value(value).required('The username field is required.');
    },

    'regInfo.email': function(value) {
      return Validator.value(value).required('The email field is required.').email();
    },

    'regInfo.password': function(value) {
      return Validator.value(value).required('The password field is required.');
    },

    'confirmPwd,regInfo.password': function(confirmPwd, password) {
      if(this.submitted || this.validation.isTouched('confirmPwd')){
        return Validator.value(confirmPwd).required('The confirm password field is required').match(password);
      }
    },

    'regInfo.is_agree': function(value) {
      return Validator.custom(function() {
        if (!value) {
          return 'Please agree to our Terms and Conditions and Privacy Policy.'
        }
      });
    },
  },

  computed: {
    disableBtn() {
      if (this.regInfo.username && this.regInfo.password && this.validation.isPassed('regInfo.email') && this.regInfo.is_agree && this.validation.isPassed('confirmPwd')) {
        return {
          opacity: 1
        };
      } else {
        return {
          opacity: .3
        }
      }
    },
    hostname() {
      return window.location.host.replace('www.','') || 'freelink.com';
    }
  },

  methods: {
    submitForm: function (info) {
      this.submitted = true;
      this.$validate()
        .then((success)=> {
          if (success) {
            this.clearErrMsg();
            if (this.is_loading) return;
            this.is_loading = true;
            loading.show();
            userService.register(info)
            .then((res) => {
              console.log(res)
              this.toActivateAccount();
            })
            .catch((err) => {
              if (err instanceof validateError) {
                const validate = err.getError();
                if (validate.username) {
                  this.errName = validate.username;
                  this.validateName = true
                }

                if (validate.email) {
                  this.errEmail = validate.email;
                  this.validateEmail = true
                }

                if (validate.password) {
                  this.errPsw = validate.password;
                  this.validatePsw = true;
                }
              }
            })
            .finally(() => {
              this.is_loading = false;
              loading.hide();
            })
          }
        });
    },

    //清除校验信息
    clearErrMsg: function () {
      this.validateName = false,
      this.validateEmail = false,
      this.validatePsw = false,
      this.errName = '',
      this.errEmail = '',
      this.errPsw = ''
    },

    toLogin: function () {
      this.$router.push({
        path: "/sign-in",
      })
    },

    handleToggleIcon() {
      this.regInfo.is_agree = !this.regInfo.is_agree;
    },

    toActivateAccount: function () {
      userService.login({'username': this.regInfo.username,'password': this.regInfo.password})
      .then((res)=>{
        LS.set('token',res.data.token)
        this.$router.push({
          path: "/activate"
        })
      })
      .then((err)=>{
        console.log(err)
      })
    },

    /**
     * 控制密码显示隐藏
     */
    handlePwdVisibility:function(){
      this.showPwd = !this.showPwd;
    },

    confirmPwdVisibility:function(){
      this.showConfirmPwd = !this.showConfirmPwd;
    },
  }
}
</script>